import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPaperPlane, faLocationDot, faCircleInfo } from '@fortawesome/free-solid-svg-icons';

function ContactSection() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState({
        message: '',
        type: ''
    });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ message: '', type: '' });

        try {
            const response = await fetch('https://usscfedora.org/emailhandler.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (data.status === 'success') {
                setStatus({
                    message: 'Message sent successfully! We\'ll get back to you soon.',
                    type: 'success'
                });
                setFormData({ name: '', email: '', subject: '', message: '' });
            } else {
                setStatus({
                    message: data.message || 'Something went wrong. Please try again.',
                    type: 'danger'
                });
            }
        } catch (error) {
            setStatus({
                message: 'An error occurred. Please try again later.',
                type: 'danger'
            });
        }

        setLoading(false);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <section className="landing-page-contact">
            <div className="cyber-grid"></div>
            <Container fluid>
                <Row className="justify-content-center">
                    <Col md={10} lg={8} className="text-center mb-5">
                        <h2 className="landing-page-contact-title high-tech-font">Contact Us</h2>
                        <div className="landing-page-contact-underline"></div>
                        <p className="landing-page-contact-subtitle">
                            Want to join our team or have questions? Get in touch!
                        </p>
                    </Col>
                </Row>

                <Row className="justify-content-center g-4">
                    {/* Contact Info Card */}
                    <Col md={5} lg={4}>
                        <div className="landing-page-contact-info-card">
                            <div className="glow-effect"></div>
                            <h3 className="info-card-title">
                                <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                                Contact Information
                            </h3>
                            <div className="info-card-content">
                                <div className="info-item">
                                    <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
                                    <div className="info-text">
                                        <h4>Email Us</h4>
                                        <p>info@usscfedora.org</p>
                                    </div>
                                </div>
                                
                                <div className="info-divider"></div>
                                
                                <div className="cyber-text">
                                    <p>If you like to contact us about anything relating to cybersecurity, CTFs or just technology in general, feel free! We are currently not accepting any more members into our CTF team.</p>
                                </div>
                                
                                <div className="cyber-badge">
                                    <span className="badge-text">FEDORAMAN PROJECT</span>
                                    <div className="badge-glow"></div>
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* Contact Form */}
                    <Col md={7} lg={6}>
                        <div className="landing-page-contact-card">
                            {status.message && (
                                <Alert variant={status.type} className="mb-4">
                                    {status.message}
                                </Alert>
                            )}
                            
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        placeholder="Your name"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        placeholder="Your email"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Subject</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                        placeholder="Message subject"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows={5}
                                        placeholder="Your message"
                                    />
                                </Form.Group>

                                <Button 
                                    type="submit" 
                                    className="contact-submit-button" 
                                    disabled={loading}
                                >
                                    <FontAwesomeIcon icon={loading ? faEnvelope : faPaperPlane} className="me-2" />
                                    {loading ? 'Sending...' : 'Send Message'}
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default ContactSection;